import { render, staticRenderFns } from "./DublettenZusammenfuehrenModal.vue?vue&type=template&id=3f0baf74"
import script from "./DublettenZusammenfuehrenModal.vue?vue&type=script&lang=js"
export * from "./DublettenZusammenfuehrenModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports